<div *ngIf="curBanner" class="banner-container">
  <div
    class="icon-navigate transparent prev"
    (click)="hasPrev() ? prev() : null"
    [class.disabled]="!hasPrev()"
  >
    <img src="assets\img\Right.svg" [class.rotateY]="!isRTL" />
  </div>

  <div class="img-container">
    <div
      *ngFor="let i of data?.banners"
      class="banner"
      [class.hidden]="i !== curBanner"
    >
      <img
        *ngIf="!curBanner.linkUrl"
        [src]="curBanner.imgUrl"
        class="img-banner"
      />
      <a *ngIf="curBanner.linkUrl" [href]="curBanner.linkUrl" target="_blank"
        ><img [src]="curBanner.imgUrl" class="img-banner"
      /></a>
    </div>

    <button
      *ngIf="allowEdit"
      (click)="displayEditBanners = true"
      class="btn-edit t-button-outline"
    >
      {{ "translate.dashboard.edit" | translate }}
    </button>
  </div>

  <div
    class="icon-navigate transparent next"
    (click)="hasNext() ? next() : null"
    [class.disabled]="!hasNext()"
  >
    <img src="assets\img\Right.svg" [class.rotateY]="isRTL" />
  </div>
</div>

<div *ngIf="!curBanner && allowEdit" class="empty-banner-container">
  <img src="assets\img\Banner_Upload.svg" />
  <a (click)="displayEditBanners = true">{{
    "translate.dashboard.emptyBannerBoxMsg" | translate
  }}</a>
</div>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="displayEditBanners = false"
  [isOpen]="displayEditBanners"
  [focusOnOpen]="false"
  [draggable]="false"
>
  <edit-banners
    *ngIf="displayEditBanners"
    class="t-scrollbar"
    (onCancel)="displayEditBanners = false"
  ></edit-banners>
</modal-popup>
